import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto3() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.64 51.52" width="47px">
			<g id="Calque_2" data-name="Calque 2">
				<g id="design">
					<path d="M36.81,4.44V0H29.75V4.44H11.84V0H4.78V4.44H0V34.68a6.69,6.69,0,0,0,6.68,6.68H21.09a15.54,15.54,0,0,1-.51-2.29H6.68a4.4,4.4,0,0,1-4.39-4.39V15.52H39.08v4.93a15.81,15.81,0,0,1,2.29.5V4.44ZM32,2.29h2.48V8.57H32Zm-25,0H9.55V8.57H7.07Zm32,10.94H2.29V6.73H4.78v4.13h7.06V6.73H29.75v4.13h7.06V6.73h2.27Z" />
					<path d="M41.37,22.46a14.69,14.69,0,0,0-2.29-.55,14.06,14.06,0,0,0-2.35-.19,14.92,14.92,0,0,0-14.9,14.9A14,14,0,0,0,22,39.07a14.2,14.2,0,0,0,.57,2.29,14.9,14.9,0,1,0,18.76-18.9ZM36.73,49.23a12.64,12.64,0,0,1-11.68-7.87,12.46,12.46,0,0,1-.93-4.74A12.63,12.63,0,0,1,36.73,24a12.16,12.16,0,0,1,2.35.22,11.63,11.63,0,0,1,2.29.67,12.6,12.6,0,0,1-4.64,24.33Z" />
					<polygon points="44.35 42.52 43.54 43.33 42.73 44.14 38.65 40.06 37 38.41 35.68 37.1 35.68 29.71 37.98 29.71 37.98 36.15 38.56 36.74 40.23 38.4 41.97 40.15 44.35 42.52" />
				</g>
			</g>
		</svg>
	);
}
